import React, { useContext, useEffect } from 'react';
import { Message } from '@aws-amplify/ui-react';
import { MessageContext } from '../../context/MessageContext';
import './GlobalMessage.css';

const GlobalMessage = () => {
  const { text, type, clearMessage } = useContext(MessageContext);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | undefined;
    if (text && type !== 'error') {
      timer = setTimeout(clearMessage, 30000);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [text, type, clearMessage]);

  const isAlert = type === 'error' || type === 'warning';

  if (!text) return null;

  return (
    <Message
      colorTheme={type}
      isDismissible
      onDismiss={clearMessage}
      position="fixed"
      top="0"
      left="0"
      right="0"
      role={isAlert ? 'alert' : 'status'}
      className="global-message"
    >
      {text}
    </Message>
  );
};

export default GlobalMessage;
